import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useCheckoutState } from '../../../../utils/checkoutState';
import useUnzer from '../../../../utils/useUnzer';
import './style.scss';

type BankChangeEvent = {
  value: string;
};

// https://docs.unzer.com/payment-methods/ideal/accept-ideal-ui-component/
const UnzerIdeal = () => {
  const { checkoutState } = useCheckoutState();
  const selectedPaymentOption = checkoutState.orderState.payment?.selected?.[0];
  const { isLoading, unzerInstance } = useUnzer('unzer_ideal');
  const { setFieldValue } = useFormikContext<{ unzerIdeal: { isValid: boolean } }>();

  const handleUnzerBankChange = (e: BankChangeEvent) => {
    if (!e.value) {
      return;
    }

    setFieldValue('unzerIdeal', { isValid: true });
  };

  useEffect(() => {
    if (!unzerInstance) {
      return;
    }
    const unzerElementExists =
      IS_WEB_COMPONENT && !import.meta.env.DEV && !!document.getElementById('ideal-bank-select')?.hasChildNodes();

    if (!unzerElementExists) {
      const ideal = unzerInstance.Ideal();
      ideal.create('ideal', { containerId: 'ideal-bank-select' });

      if (!window.unzerIdeal) {
        window.unzerIdeal = ideal;
      }

      setTimeout(() => {
        window.unzerIdeal?.addEventListener('change', handleUnzerBankChange);
      }, 10);
    }
  }, [unzerInstance]);

  useEffect(
    () => () => {
      delete window.unzerIdeal;
      setFieldValue('unzerIdeal', { isValid: false });

      if (IS_WEB_COMPONENT && !import.meta.env.DEV) {
        const unzerIdealContainer = document.getElementById('ideal-bank-select');
        if (unzerIdealContainer) {
          unzerIdealContainer.innerHTML = '';
        }
      }
    },
    []
  );

  if (selectedPaymentOption?.paymentOptionKey !== 'unzer_ideal' || isLoading) {
    return null;
  }

  return (
    <>
      {IS_WEB_COMPONENT && !import.meta.env.DEV ?
        <slot name="unzer-ideal-container" id="unzer-ideal-container" className="unzerUI form">
          <slot name="ideal-bank-select" id="ideal-bank-select" className="field" />
        </slot>
      : <form id="payment-form unzer-ideal-container" className="unzerUI form" noValidate>
          <div id="ideal-bank-select" className="field"></div>
        </form>
      }
    </>
  );
};

export default UnzerIdeal;
